// -- import * as _ from "lodash-es"
import * as api from "../../shared/api"
import * as biz_data_helper from "../../shared/biz_data_helper"

const content_type = ""

const create = function () {
  return {
    content_type: "muji",
    age: 29
  }
}
const descriptor = {}

const biz_data = new biz_data_helper.base_entity_helper(
  content_type,
  create,
  descriptor
)

const fields = {
  detail_invent: [
    { key: 'LineNum', label: '行号', sortable: true, thStyle: { width: "60px" } },
    {
      key: 'ItemId', label: '物料编号', sortable: true,
      type: "text_integer",
      required: true,
      editable: true,
      style: "width:100%",
      thStyle: {
        width: "10rem"
      }
    },
    {
      key: 'NameAlias', label: '物料名称', sortable: true, required: true,
      width: "8rem",
      thStyle: {
        width: "8rem"
      },
    },
    {
      key: 'FromBatchQty', label: '开始数量', sortable: true, type: "number",
    },
    {
      key: 'BatchQty', label: '结束数量', sortable: true, type: "number",
    },
    {
      key: 'IsHomemade', label: '是否接受外协', sortable: true,
      width: "7rem",
      thStyle: {
        width: "7rem"
      },
      formatter: (value, key, item) => {
        if (item.IsHomemade == 1) return "是"
        else if (item.IsHomemade == 2) return "纯外协"
        else return "否"
      }
    },
    {
      key: 'UnfoldSize', label: '展开尺寸', sortable: true,
      type: "text",
      required: true,
      editable: true,
      style: "width:100%",
      thStyle: {
        width: "10rem"
      }
    },
    {
      key: 'PurchUser', label: '采购员', sortable: true,
      required: true,
      editable: true,
      _options: {}
    },
    {
      key: 'Description', label: '描述', sortable: true,
      thStyle: {
        width: "8rem"
      }
    },
    {
      key: 'closed',
      label: '关闭状态',
      type: 'state_closed',
      context: ["正常", "待关闭", "已关闭"]
    },
    {
      key: 'fcCheckSQOConsultApplayIsCreated', label: '有询价申请', sortable: true,
      type: "boolean",
      thStyle: {
        width: "6rem"
      }
    },
    { key: 'InventHandleBy', label: '处理人', sortable: true },
    { key: 'InventHandleAt', label: '处理时间', sortable: true, type: "datetime" },
    {
      key: 'Accessory',
      label: '附件',
      type: "button",
      button: {
        type: "text",
        icon_class: "iconfont icon-fujian",
        label: "",
        show_label: true
      },
      thStyle: { width: "70px" }
    },
  ],
  detail_bom: [
    { key: 'LineNum', label: '行号', sortable: true, thStyle: { width: "60px" } },
    {
      key: 'ItemId', label: '物料编号', sortable: true,
      thStyle: {
        width: "10rem"
      }
    },
    {
      key: 'NameAlias', label: '物料名称', sortable: true,
      type: "short",
      thStyle: {
        width: "12rem"
      }
    },
    {
      key: 'Manufacturer', label: '制造商', sortable: true, type: "select_multiple", multiple: true,
      collapse_tags: true,
      thStyle: {
        width: "12rem"
      }
    },
    {
      key: 'BomConfirmState', label: 'BOM已确认', sortable: true,
      type: "boolean",
      thStyle: {
        width: "6rem"
      }
    },

  ],
  detail_bom_handle: [
    {
      key: "dataAreaId",
      label: "制造商",
      sortable: true,
      thStyle: {
        width: "4rem"
      }
    },
    {
      key: "AccountNum",
      label: "供应商编号",
      sortable: true,
      width: "6rem",
      thStyle: {
        width: "6rem"
      }
    },
    {
      key: "AccountName",
      label: "供应商名称",
      sortable: true,
      thStyle: { width: "9rem" },
      width: "9rem",
      type: "short"
    },
    {
      key: 'BomID', label: 'Bom编号', sortable: true,
      type: "textarea",
      required: true,
      // editable: true,
      thStyle: {
        width: "8rem"
      }
    },
    {
      key: "BomVersionName",
      label: "BOM版本名称",
      sortable: true,
      thStyle: { width: "10rem" },
      width: "10rem",
      type: "short"
    },
    {
      key: 'activeBomID', label: '有效Bom编号', sortable: true,
      thStyle: {
        width: "8rem"
      }
    },
  ],
  detail_route: [
    { key: 'LineNum', label: '行号', sortable: true, thStyle: { width: "60px" } },
    {
      key: 'ItemId', label: '物料编号', sortable: true,
      thStyle: {
        width: "10rem"
      }
    },
    {
      key: 'NameAlias', label: '物料名称', sortable: true,
      type: "short",
      thStyle: {
        width: "12rem"
      }
    },
    {
      key: 'Manufacturer', label: '制造商', sortable: true, type: "select_multiple", multiple: true,
      collapse_tags: true,
      thStyle: {
        width: "12rem"
      }
    },
    {
      key: 'RouteConfirmState', label: '工艺已确认', sortable: true,
      type: "boolean",
      thStyle: {
        width: "6rem"
      }
    },
  ],
  detail_route_handle: [
    {
      key: "dataAreaId",
      label: "制造商",
      sortable: true,
      thStyle: {
        width: "4rem"
      }
    },
    {
      key: "AccountNum",
      label: "供应商编号",
      sortable: true,
      width: "6rem",
      thStyle: {
        width: "6rem"
      }
    },
    {
      key: "AccountName",
      label: "供应商名称",
      sortable: true,
      thStyle: { width: "9rem" },
      width: "9rem",
      type: "short"
    },
    {
      key: 'RouteID', label: '工艺路线编号', sortable: true,
      type: "textarea",
      // editable: true,
      required: true,
      thStyle: {
        width: "8rem"
      }
    },
    {
      key: "RouteVersionName",
      label: "工艺路线名称",
      sortable: true,
      thStyle: { width: "10rem" },
      width: "10rem",
      type: "short"
    },
    {
      key: 'activeRouteID', label: '有效工艺编号', sortable: true,
      thStyle: {
        width: "8rem"
      }
    },
  ],
  detail_transport_cost: [
    { key: 'LineNum', label: '行号', sortable: true, thStyle: { width: "60px" } },
    {
      key: 'ItemId', label: '物料编号', sortable: true,
      thStyle: {
        width: "8rem"
      }
    },
    {
      key: 'NameAlias', label: '物料名称', sortable: true,
      type: "short",
      thStyle: {
        width: "12rem"
      }
    },
    {
      key: 'DeliveryAddress', label: '交货地址', sortable: true,
      type: "short",
      thStyle: {
        width: "8rem"
      }
    },
    {
      key: 'DeliveryMode', label: '运输方式', sortable: true,
      type: "short",
      thStyle: {
        width: "8rem"
      }
    },
    { key: 'BatchQty', label: '数量', sortable: true, type: "number", thStyle: { width: "6rem" } },
    {
      key: 'Manufacturer', label: '制造商', sortable: true, type: "select_multiple", multiple: true,
      collapse_tags: true,
      thStyle: {
        width: "12rem"
      }
    },
    {
      key: 'TransportConfirmState', label: '其他成本已确认', sortable: true,
      type: "boolean",
      thStyle: {
        width: "10rem"
      }
    },
  ],
  detail_transport_handle: [
    {
      key: "dataAreaId",
      label: "制造商编号",
      sortable: true,
      thStyle: {
        width: "6rem"
      }
    },
    {
      key: "AccountNum",
      label: "供应商编号",
      sortable: true,
      thStyle: {
        width: "6rem"
      }
    },
    {
      key: "AccountName",
      label: "供应商名称",
      sortable: true,
      thStyle: { width: "12rem" },
      width: "12rem",
      type: "short"
    },
    {
      key: "CostName",
      label: "其他成本类别",
      sortable: true,
      thStyle: { width: "10rem" },
      width: "10rem",
      type: "short"
    },
    {
      key: 'TransportCost', label: '其他成本', sortable: true,
      type: "number",
      editable: true,
      required: true,
    },
  ],
  detail_distribution: [
    { key: 'LineNum', label: '行号', sortable: true, thStyle: { width: "60px" } },
    {
      key: 'AccountNum', label: '供应商编号', sortable: true,
      thStyle: {
        width: "6rem"
      }
    },
    {
      key: 'AccountName', label: '供应商名称', sortable: true,
      thStyle: {
        width: "12rem"
      }
    },
    { key: 'FromBatchQty', label: '起始数量', sortable: true, type: "number", thStyle: { width: "6rem" } },
    { key: 'BatchQty', label: '结束数量', sortable: true, type: "number", thStyle: { width: "6rem" } },
    {
      key: 'DistributionRate', label: '比例(%)', sortable: true,
      type: "number",
      editable: true,
      required: true,
      width: "200px",
      thStyle: {
        width: "8rem"
      }
    },
    { key: 'Qty', label: '分配数量', sortable: true, type: "number", thStyle: { width: "6rem" } },
    { key: 'TotalCost', label: '总成本', sortable: true, type: "number", thStyle: { width: "6rem" } },
    { key: 'PerPrice', label: '单位成本/报价', sortable: true, type: "number", thStyle: { width: "8rem" } },
    { key: 'DistributionRatePre', label: '采购分配比例(%)', sortable: true, thStyle: { width: "8rem" } },
    {
      key: 'Description', label: '描述', sortable: true,
      type: "textarea",
      editable: true,
      required: true
    },
    // { key: 'DeliveryAddress', label: '送货地址', sortable: true },
    // { key: 'DeliveryMode', label: '送货方式', sortable: true },
  ],
  detail_distribution_search_default: [
    { key: 'QuotationTaskNum', label: '报价申请编号', sortable: true, thStyle: { width: "8rem" } },
    { key: 'CustAccount', label: '客户账户', sortable: true },
    {
      key: 'CustName', label: '客户名称', sortable: true, type: "short",
      thStyle: {
        width: "12rem"
      }
    },
    {
      key: "dataAreaId",
      label: "销售公司",
      sortable: true,
      thStyle: {
        width: "5rem"
      }
    },
    {
      key: "CompanyName",
      label: "销售公司名称",
      sortable: true,
      thStyle: { width: "12rem" },
      type: "short"
    },

    { key: 'QuotationTaskLineNum', label: '行号', sortable: true },
    { key: 'ItemId', label: '物料编号', sortable: true, thStyle: { width: "6rem" } },
    {
      key: 'NameAlias', label: '物料名称', sortable: true, type: "textarea", required: true,
      thStyle: {
        width: "12rem"
      }
    },
    { key: 'FromBatchQty', label: '起始数量', sortable: true, type: "number", },
    { key: 'BatchQty', label: '结束数量', sortable: true, type: "number", },
    { key: 'Price', label: '报价', sortable: true, type: "just_number", required: true, },
    {
      key: 'InclTax', label: '价格是否含税', sortable: true, thStyle: {
        width: "8rem"
      }
    },
    {
      key: 'closed',
      label: '关闭状态',
      type: 'state_closed',
      context: ["正常", "待关闭", "已关闭"]
    },
    {
      key: "fcCheckSQODApproved",
      label: "审批",
      sortable: true,
      type: "state",
      state_control: "fcCheckSQODApproved",
      other_type_key: "is_weightcost_refused",
      context: ["待审批", "已审批", "已退回"]
    },
    { key: "SQODApprover", label: "待审批人", sortable: true, thStyle: { width: "8rem" } },
    {
      key: 'ApproveRemark', label: '审批意见', sortable: true, type: "html",
      thStyle: { width: "12rem" }
    },
  ],
  detail_distribution_search_proofing_default: [
    {
      key: "id",
      label: "id",
      sortable: true,
      thStyle: {
        display: "none"
      },
      tdClass: "no-shown-RetailVariantId",
    },
    {
      key: "IsHomemade",
      label: "IsHomemade",
      sortable: true,
      thStyle: {
        display: "none"
      },
      tdClass: "no-shown-RetailVariantId",
    },
    {
      key: "GrossProfitMarginProofing",
      label: "GrossProfitMarginProofing",
      sortable: true,
      thStyle: {
        display: "none"
      },
      tdClass: "no-shown-RetailVariantId",
    },
    { key: 'QuotationTaskNum', label: '报价申请编号', sortable: true, thStyle: { width: "8rem" } },
    { key: 'CustAccount', label: '客户账户', sortable: true },
    {
      key: 'CustName', label: '客户名称', sortable: true, type: "short",
      thStyle: {
        width: "12rem"
      }
    },
    {
      key: "dataAreaId",
      label: "销售公司",
      sortable: true,
      thStyle: {
        width: "5rem"
      }
    },
    {
      key: "CompanyName",
      label: "销售公司名称",
      sortable: true,
      thStyle: { width: "12rem" },
      type: "short"
    },

    { key: 'QuotationTaskLineNum', label: '行号', sortable: true },
    { key: 'ItemId', label: '物料编号', sortable: true, thStyle: { width: "6rem" } },
    {
      key: 'NameAlias', label: '物料名称', sortable: true, type: "textarea", required: true,
      thStyle: {
        width: "12rem"
      }
    },
    { key: 'FromBatchQty', label: '起始数量', sortable: true, type: "number", },
    { key: 'BatchQty', label: '结束数量', sortable: true, type: "number", },
    { key: 'Price', label: '报价', sortable: true, type: "just_number", required: true, },
    {
      key: 'InclTax', label: '价格是否含税', sortable: true, thStyle: {
        width: "8rem"
      }
    },
    {
      key: 'closed',
      label: '关闭状态',
      type: 'state_closed',
      context: ["正常", "待关闭", "已关闭"]
    },
    {
      key: "is_approved",
      label: "审批",
      sortable: true,
      type: "state",
      state_control: "is_approved",
      other_type_key: "is_weightcost_refused",
      context: ["待审批", "已审批", "已退回"]
    },
    { key: "qt_create_by_username", label: "待审批人", sortable: true, thStyle: { width: "8rem" } },
    // {
    //   key: 'ApproveRemark', label: '审批意见', sortable: true, type: "html",
    //   thStyle: { width: "12rem" }
    // },
  ],
  detail_distribution_search_item: [
    { key: 'LineNum', label: '分配行号', sortable: true, thStyle: { width: "5rem" } },
    { key: 'AccountNum', label: '供应商编号', sortable: true, thStyle: { width: "6rem" } },
    {
      key: 'AccountName', label: '供应商名称', sortable: true,
      thStyle: {
        width: "12rem"
      }
    },
    { key: 'TotalCost', label: '成本（报价）', sortable: true, type: "number", thStyle: { width: "8rem" }, },
    { key: 'PerPrice', label: '单位成本', sortable: true, type: "number", thStyle: { width: "6rem" }, },
    {
      key: 'DistributionRate', label: '分配比例(%)', sortable: true,
      type: "number",
      thStyle: {
        width: "8rem"
      }
    },
    { key: 'Qty', label: '分配数量', sortable: true, type: "number", thStyle: { width: "6rem" } },
    { key: 'Description', label: '描述', sortable: true, type: "short", },
    {
      key: 'VendAccessory',
      label: '供应商附件',
      type: "button",
      button: {
        type: "text",
        icon_class: "iconfont icon-fujian",
        label: "",
        show_label: true
      },
      thStyle: { width: "80px" }
    },
  ],
  detail_invent_price: [
    { key: 'LineNum', label: '行号', sortable: true, thStyle: { width: "60px" } },
    {
      key: 'ItemId', label: '物料编号', sortable: true,
      thStyle: {
        width: "10rem"
      }
    },
    {
      key: 'NameAlias', label: '物料名称', sortable: true,
      type: "short",
      thStyle: {
        width: "12rem"
      }
    },
    { key: 'BatchQty', label: '数量', sortable: true, type: "number", thStyle: { width: "6rem" } },
    {
      key: 'Manufacturer', label: '制造商', sortable: true, type: "select_multiple", multiple: true,
      collapse_tags: true,
      thStyle: {
        width: "12rem"
      }
    },

    {
      key: 'InventPriceConfirmState', label: '物料价格已确认', sortable: true,
      type: "boolean",
      thStyle: {
        width: "6rem"
      }
    },

  ],
  detail_qth_invent_price_fields: [
    {
      key: "AccountNum",
      label: "制造商编号",
      sortable: true,
      thStyle: {
        width: "6rem"
      }
    },
    {
      key: "AccountName",
      label: "制造商名称",
      sortable: true,
      thStyle: { width: "12rem" },
      width: "12rem",
      type: "short"
    },
    {
      key: 'BomID', label: 'Bom编号', sortable: true,
      type: "textarea",
      thStyle: {
        width: "10rem"
      }
    },
    {
      key: 'RouteID', label: '工艺路线编号', sortable: true,
      type: "textarea",
      thStyle: {
        width: "10rem"
      }
    },
    { key: 'CostDetail', label: '物料价格详情', sortable: true, type: "button", button: { type: "text", icon_class: "iconfont icon-look" }, },
  ],
  confirm_invent_price_fields: [
    { key: "dataAreaId", label: "工厂", sortable: true, thStyle: { width: "6rem" } },
    { key: "CostGroupId", label: "类别", sortable: true, },
    { key: 'ItemId', label: '物料编号', sortable: true, },
    {
      key: 'NameAlias', label: '物料名称', sortable: true, thStyle: { width: "16rem" },
      width: "16rem",
    },
    { key: 'DW_InventUnitId', label: '单位', sortable: true },
    { key: 'real_qty', label: '数量', sortable: true, type: "number" },
    { key: 'TEC_Weight', label: '重量(吨)', sortable: true, type: "number" },
    { key: 'PmfProductType', label: '生产类型', sortable: true },
    { key: 'purch_price', label: '采购协议价', sortable: true, type: "number" },
    { key: 'cacl_price_wotax', label: '不含税成本计算价', editable: true, sortable: true, type: "number" },
  ],
  confirm_invent_vend_price_fields: [
    { key: 'ItemId', label: '物料编号', sortable: true, },
    { key: 'AccountNum', label: '供应商账号', sortable: true, },
    {
      key: 'AccountName', label: '供应商名称', sortable: true, thStyle: { width: "12rem" },
      width: "12rem",
      type: "short"
    },
    { key: 'real_qty', label: '数量(从)', sortable: true, type: "number" },
    { key: 'TEC_Weight', label: '数量(到)', sortable: true, type: "number" },
    { key: 'DW_InventUnitId', label: '单位', sortable: true },
    { key: 'Currency', label: '币种', sortable: true, },
    { key: 'Amount', label: '含税价', sortable: true, type: "number" },
    { key: 'ExchangeRate', label: '汇率', sortable: true, type: "number" },
    { key: 'SEI_TaxValue', label: '税率', sortable: true, type: "number" },
    { key: 'amount_wotax', label: '不含税本币价', sortable: true, type: "textarea" },
  ],
}

const dataForm = {}

///前端验证
const rules = {}

const methods = {
  //获取报价申请主计划
  async getDistributionData(_params) {
    let distribut_biz_data = new biz_data_helper.base_entity_helper("sPlant_QuotationTask_Distribution", {}, {})
    let f = _.map(fields.detail_distribution, "key")
    f.push("id")
    f.push("QuotationTaskDetailId")
    f.push("SEI_Name")
    f.push("IsHomeMade")
    f.push("create_by")
    f.push("dataAreaId")
    f.push("OtherCost")

    let result = await distribut_biz_data.selectAction({ params: _params, fields: f }).run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  async saveDistributionData(params) {
    let f = _.map(fields.detail_distribution, "key")
    f.push("id")
    f.push("QuotationTaskDetailId")
    f.push("BatchQty")
    let detail_biz_data = new biz_data_helper.base_entity_helper("sPlant_QuotationTask_Distribution", {}, {})
    let qt_detail_biz_data = new biz_data_helper.base_entity_helper("update_quote_detail_weightedcost", {}, {})
    let qto_approve_biz_data = new biz_data_helper.base_entity_helper("sp_updateApproveStatus", {}, {})
    let update_status_biz_data = new biz_data_helper.base_entity_helper("update_approve_status", {}, {})
    let renew_biz_data = new biz_data_helper.base_entity_helper("renew_pre_distribution_from_plan", {}, {})
    let _actions = []
    for (var k in params) {
      if (k == "add" && params[k].length > 0) {
        _.each(params[k], (t) => {
          _actions.push(
            detail_biz_data.insertAction({
              params: t,
              fields: f
            }).action({
              output_last_item_map: {
                QuotationTaskDetailId: "itemId"
              }
            })
          )
          ///销售报价分配审批
          let sq_form = {
            itemId: "",
            documentType: "SalesQuoteDistribution",
            approveType: "",
            documentCreateByUsername: params.documentCreateByUsername
          }
          _actions.push(
            qto_approve_biz_data.execAction({
              params: sq_form,
              fields: ["id"]
            }).action({
              mixin_last_item_map: {
                itemId: "itemId"
              }
            })
          )
        })
      }
      else if (k == "edit" && params[k].length > 0) {
        _.each(params[k], (t) => {
          _actions.push(
            detail_biz_data.updateAction({
              params: t,
              fields: f
            }).action({})
          )
          ///销售报价分配审批
          let sq_form = {
            itemId: t.QuotationTaskDetailId,
            documentType: "SalesQuoteDistribution",
            approveType: "",
            documentCreateByUsername: params.documentCreateByUsername
          }
          _actions.push(
            qto_approve_biz_data.execAction({
              params: sq_form,
              fields: ["id"]
            }).action({})
          )
        })
      }
      else if (k == "delete" && params[k].length > 0) {
        _actions.push(
          detail_biz_data.removeAction({
            params: params[k],
            fields: f
          }).action({})
        )
      }
      else if (k == "approved") {
        ///修改审批状态
        let dt = _.map(params[k].approveStatusIdList, (t) => {
          return {
            IsApproved: t.isApproved ? 0 : 1,
            ApproveBy: params[k].local_username,
            status_id: t.id,
            ApproveRemark: params[k].ApproveRemark //审批备注
          }
        })
        _actions.push(
          update_status_biz_data.execAction({
            params: dt,
            fields: ["is_update_ok", "is_all_approved"]
          }).action({})
        )
        ///更新加权成本
        let dt1 = _.map(params[k].data, (t) => { return { QuotationTaskDetailId: t.QuotationTaskDetailId, WeightCostCreateUser: params[k].local_username } })
        _actions.push(
          qt_detail_biz_data.execAction({
            params: _.uniqBy(dt1, "QuotationTaskDetailId"),
            fields: []
          }).action({})
        )
        ///添加加权审批
        if (params[k].weightConfirmList && params[k].weightConfirmList.length > 0) {
          for (var i in params[k].weightConfirmList) {
            let sq_form = {
              itemId: params[k].weightConfirmList[i],
              documentType: "SalesQuoteWeightCost",
              approveType: "",
              documentCreateByUsername: params[k].local_username
            }
            _actions.push(
              qto_approve_biz_data.execAction({
                params: sq_form,
                fields: []
              }).action({})
            )
          }
        }
        ///物料分配比例更新到预分配
        if (params[k].renewPreDistributionList && params[k].renewPreDistributionList.length > 0) {
          _actions.push(
            renew_biz_data.execAction({
              params: params[k].renewPreDistributionList,
              fields: []
            }).action({})
          )
        }
      }
    }
    let result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      let is_error = false
      _.each(result.data.BatchResult.Actions, (t) => {
        if (!t.Result.Data) {
          is_error = true
        }
      })
      if (is_error) return null
      else {
        let rt = { add: [], edit: [], delete: [] }
        _.each(result.data.BatchResult.Actions, (t) => {
          if (t.Code.indexOf("data/i/") > -1) rt.add = t.Result.Data[0]
          else if (t.Code.indexOf("data/u/") > -1) rt.edit = t.Result.Data[0]
          else if (t.Code.indexOf("data/d/") > -1) rt.delete = t.Result.Data[0]
        })
        return rt
      }
    } else {
      return null
    }
  },
  async saveDistributionProofingData(params) {
    let f = _.map(fields.detail_distribution, "key")
    f.push("id")
    f.push("QuotationTaskDetailId")
    f.push("BatchQty")
    let detail_biz_data = new biz_data_helper.base_entity_helper("sPlant_QuotationTask_Distribution", {}, {})
    let qto_approve_biz_data = new biz_data_helper.base_entity_helper("sp_updateApproveStatus_SalesQuote", {}, {})
    let _actions = []
    for (var k in params) {
      if (k == "add" && params[k].length > 0) {
        _.each(params[k], (t) => {
          _actions.push(
            detail_biz_data.insertAction({
              params: t,
              fields: f
            }).action({
              output_last_item_map: {
                QuotationTaskDetailId: "itemId"
              }
            })
          )
        })
      }
      else if (k == "edit" && params[k].length > 0) {
        _.each(params[k], (t) => {
          _actions.push(
            detail_biz_data.updateAction({
              params: t,
              fields: f
            }).action({})
          )
        })
      }
      else if (k == "delete" && params[k].length > 0) {
        _actions.push(
          detail_biz_data.removeAction({
            params: params[k],
            fields: f
          }).action({})
        )
      }
      else if (k == "approved") {
        _actions.push(
          detail_biz_data.approveAction({
            params: params[k].data.map((t) => { return { id: t.id, is_approved: !t.is_approved } }),
            fields: f
          }).action({})
        )
        if (params[k].quote_order_approved && params[k].quote_order_approved.length > 0) {
          _actions.push(
            qto_approve_biz_data.execAction({
              params: params[k].quote_order_approved.map((t) => {
                return {
                  ItemId: t.itemId,
                  DocumentType: "SalesQuoteOrder",
                  ApproveType: "",
                  DocumentCreateBy: t.documentCreateByUsername,
                  is_factory: t.is_factory,
                  LtTargetProfit: t.LtTargetProfit
                }
              }),
              fields: ["id"]
            }).action({})
          )
        }
      }

    }
    let result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      let is_error = false
      _.each(result.data.BatchResult.Actions, (t) => {
        if (!t.Result.Data) {
          is_error = true
        }
      })
      if (is_error) return null
      else {
        let rt = { add: [], edit: [], delete: [] }
        _.each(result.data.BatchResult.Actions, (t) => {
          if (t.Code.indexOf("data/i/") > -1) rt.add = t.Result.Data[0]
          else if (t.Code.indexOf("data/u/") > -1) rt.edit = t.Result.Data[0]
          else if (t.Code.indexOf("data/d/") > -1) rt.delete = t.Result.Data[0]
        })
        return rt
      }
    } else {
      return null
    }
  },
  ///获取主计划查询列表
  async getDistributionSearchData(_params) {
    let distribut_biz_data = new biz_data_helper.base_entity_helper("get_quotation_task_distribution", {}, {})
    let result = await distribut_biz_data.execAction({ params: _params, fields: [] }).run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  ///获取报价申请物料价格
  async getQuotationTaskInventPriceData(params) {
    let f = ["id", "QuotationTaskDetailId", "ItemId", "AccountNum", "Price"]
    let detail_biz_data = new biz_data_helper.base_entity_helper("sPlant_QuotationTask_Invent_Price", {}, {})
    let result = await detail_biz_data.selectAction({ params: params, fields: f }).run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  ///保存报价申请物料价格
  async saveQuotationTaskInventPriceData(params) {
    let f = ["id", "QuotationTaskDetailId", "ItemId", "AccountNum", "Price"]
    let detail_biz_data = new biz_data_helper.base_entity_helper("sPlant_QuotationTask_Invent_Price", {}, {})
    let del_qtip_biz_data = new biz_data_helper.base_entity_helper("delete_quote_invent_price", {}, {})

    let _actions = []
    for (var k in params) {
      if (k == "remove" && params[k]) {
        _actions.push(
          del_qtip_biz_data.execAction({ params: params[k], fields: [] }).action({})
        )
      }
      if (k == "add" && params[k].length > 0) {
        _actions.push(
          detail_biz_data.insertAction({
            params: params[k],
            fields: f
          }).action({})
        )
      }
    }
    let result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      return result.data.BatchResult.Actions[1].Result.Data[0]
    } else {
      return null
    }
  },

  ///获取报价申请物料价格
  async getInventPurchDicPriceData(params) {
    let f = _.map(fields.confirm_invent_vend_price_fields, "key")
    let detail_biz_data = new biz_data_helper.base_entity_helper("get_invent_purch_dic_price", {}, {})
    let result = await detail_biz_data.execAction({ params: params, fields: f }).run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  ///生成询价申请及询价单
  async generateConsultApplayAndOrder(params) {
    let check_detail_biz_data = new biz_data_helper.base_entity_helper("generate_consult_applay_and_order", {}, {})
    let _actions = []
    _actions.push(
      check_detail_biz_data.execAction({
        params: params,
        fields: ['isOk']
      }).action({})
    )
    let result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      let rt = result.data.BatchResult.Actions[0].Result.Data
      return rt
    } else {
      return null
    }
  },
}
export { biz_data, dataForm, fields, methods, rules }

